/**
 * Header mega menu interactions.
 * Each header owns one controller so Shopify section reloads can initialize and
 * dispose listeners, animation frames, and scroll locks safely.
 */
(function () {
  "use strict";

  if (window.__beautyHeaderBootstrap) {
    window.__beautyHeaderBootstrap.init(document);
    return;
  }

  var roots = new Set();
  var SCROLL_LOCKS_KEY = "__beautyHeaderScrollLocks";
  var DESKTOP_QUERY = "(min-width: 769px)";

  function setInert(element, inert) {
    if (!element) return;
    element.toggleAttribute("inert", inert);
  }

  function getScrollLocks() {
    if (!(window[SCROLL_LOCKS_KEY] instanceof Set)) {
      window[SCROLL_LOCKS_KEY] = new Set();
    }
    return window[SCROLL_LOCKS_KEY];
  }

  function syncScrollLock() {
    var locked = getScrollLocks().size > 0;
    document.documentElement.classList.toggle("bh-scroll-locked", locked);
    document.body.classList.toggle("bh-scroll-locked", locked);
  }

  function createController(root) {
    var abortController = new AbortController();
    var signal = abortController.signal;
    var docEl = document.documentElement;
    var lockToken = {};
    var layoutFrame = null;
    var lastSaleHeight = null;
    var lastBarHeight = null;
    var resizeObserver = null;
    var headerMo = root.querySelector(".bh-mo");
    var toggle = root.querySelector(".bh-mo__toggle");
    var popup = root.querySelector(".bh-mo__popup");
    var headerSection = root.closest(".shopify-section");
    var headerTransformState = null;
    var lockedScrollY = null;
    var focusFrames = new Set();
    var mobileFocusFrame = null;

    function scheduleFocus(callback) {
      var frame = window.requestAnimationFrame(function () {
        focusFrames.delete(frame);
        if (!signal.aborted) callback();
      });
      focusFrames.add(frame);
      return frame;
    }

    function listen(target, type, handler, options) {
      if (!target) return;
      var settings = Object.assign({}, options || {}, { signal: signal });
      target.addEventListener(type, handler, settings);
    }

    function setPcMenuOpen(navItem, open) {
      var panel = navItem.querySelector(".bh-mega");
      var trigger = navItem.querySelector(".bh-nav-link");
      if (!panel) return;
      navItem.classList.toggle("is-active", open);
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      setInert(panel, !open);
      if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function closeOtherPcMenus(current) {
      root.querySelectorAll(".bh-pc .bh-nav-item.is-active").forEach(function (item) {
        if (item !== current) setPcMenuOpen(item, false);
      });
    }

    root.querySelectorAll(".bh-pc .bh-nav-item").forEach(function (navItem, navIndex) {
      var panel = navItem.querySelector(".bh-mega");
      var trigger = navItem.querySelector(".bh-nav-link");
      var sidebarItems = Array.from(navItem.querySelectorAll(".bh-mega__sidebar-item"));
      var groups = Array.from(navItem.querySelectorAll(".bh-mega__prod-group"));
      var footers = Array.from(navItem.querySelectorAll(".bh-mega__footer--cat"));

      if (panel && trigger) {
        if (!panel.id) panel.id = "bh-mega-" + navIndex;
        trigger.setAttribute("aria-haspopup", "true");
        trigger.setAttribute("aria-controls", panel.id);
        trigger.setAttribute("aria-expanded", "false");
        panel.setAttribute("aria-hidden", "true");
        setInert(panel, true);

        listen(navItem, "mouseenter", function () {
          closeOtherPcMenus(navItem);
          setPcMenuOpen(navItem, true);
        });
        listen(navItem, "mouseleave", function () {
          if (!navItem.contains(document.activeElement)) setPcMenuOpen(navItem, false);
        });
        listen(navItem, "focusin", function () {
          closeOtherPcMenus(navItem);
          setPcMenuOpen(navItem, true);
        });
        listen(navItem, "focusout", function () {
          scheduleFocus(function () {
            if (!navItem.contains(document.activeElement)) setPcMenuOpen(navItem, false);
          });
        });
        listen(navItem, "keydown", function (event) {
          if (event.key !== "Escape") return;
          event.preventDefault();
          setPcMenuOpen(navItem, false);
          trigger.focus();
        });
      }

      function activateCategory(item) {
        var index = item.getAttribute("data-cat-index");
        sidebarItems.forEach(function (other) {
          var active = other === item;
          other.classList.toggle("is-active", active);
          other.setAttribute("aria-expanded", active ? "true" : "false");
        });
        groups.forEach(function (group) {
          var active = group.getAttribute("data-cat-index") === index;
          group.classList.toggle("is-active", active);
          group.setAttribute("aria-hidden", active ? "false" : "true");
          setInert(group, !active);
        });
        footers.forEach(function (footer) {
          footer.classList.toggle("is-active", footer.getAttribute("data-cat-index") === index);
        });
      }

      sidebarItems.forEach(function (item, itemIndex) {
        var group = groups[itemIndex];
        item.setAttribute("role", "button");
        item.setAttribute("tabindex", "0");
        item.setAttribute("aria-expanded", item.classList.contains("is-active") ? "true" : "false");
        if (group) {
          if (!group.id) group.id = "bh-mega-group-" + navIndex + "-" + itemIndex;
          item.setAttribute("aria-controls", group.id);
          group.setAttribute("aria-hidden", group.classList.contains("is-active") ? "false" : "true");
          setInert(group, !group.classList.contains("is-active"));
        }
        listen(item, "mouseenter", function () {
          activateCategory(item);
        });
        listen(item, "focus", function () {
          activateCategory(item);
        });
        listen(item, "click", function () {
          activateCategory(item);
        });
        listen(item, "keydown", function (event) {
          var nextIndex = itemIndex;
          if (event.key === "ArrowDown" || event.key === "ArrowRight")
            nextIndex = (itemIndex + 1) % sidebarItems.length;
          else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            nextIndex = (itemIndex - 1 + sidebarItems.length) % sidebarItems.length;
          } else if (event.key === "Home") nextIndex = 0;
          else if (event.key === "End") nextIndex = sidebarItems.length - 1;
          else if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            activateCategory(item);
            return;
          } else return;
          event.preventDefault();
          sidebarItems[nextIndex].focus();
        });
      });
    });

    function lockScroll() {
      lockedScrollY = window.scrollY;
      getScrollLocks().add(lockToken);
      syncScrollLock();
    }

    function unlockScroll() {
      getScrollLocks().delete(lockToken);
      lockedScrollY = null;
      syncScrollLock();
    }

    function preventBackgroundScroll(event) {
      if (!getScrollLocks().has(lockToken)) return;
      if (popup && event.target instanceof Node && popup.contains(event.target)) return;
      event.preventDefault();
    }

    function onWindowScroll() {
      if (getScrollLocks().has(lockToken) && lockedScrollY !== null && Math.abs(window.scrollY - lockedScrollY) > 1) {
        window.scrollTo(0, lockedScrollY);
        return;
      }
      scheduleLayout();
    }

    function normalizeHeaderTransform() {
      if (!headerSection || headerTransformState) return;
      headerTransformState = {
        value: headerSection.style.getPropertyValue("transform"),
        priority: headerSection.style.getPropertyPriority("transform"),
      };
      headerSection.style.setProperty("transform", "none", "important");
    }

    function restoreHeaderTransform() {
      if (!headerSection || !headerTransformState) return;
      if (headerTransformState.value) {
        headerSection.style.setProperty("transform", headerTransformState.value, headerTransformState.priority);
      } else {
        headerSection.style.removeProperty("transform");
      }
      headerTransformState = null;
    }

    function applySaleHeight(height) {
      var saleHeight = Math.max(0, Math.round(Number(height) || 0));
      if (saleHeight !== lastSaleHeight) {
        lastSaleHeight = saleHeight;
        docEl.style.setProperty("--bh-sticky-top", saleHeight + "px");
      }
      return saleHeight;
    }

    function measureSaleHeightFallback() {
      var sale = document.querySelector(".sale-tab-bar-sticky");
      if (!sale || !sale.isConnected) return 0;
      var saleWrapper = sale.closest("[id^='shopify-section-']");
      if (saleWrapper && saleWrapper.classList.contains("is-scroll-hidden")) return 0;
      if (document.documentElement.classList.contains("sale-bar-session-closed")) return 0;
      return Math.round(sale.getBoundingClientRect().height);
    }

    function measureLayout() {
      layoutFrame = null;
      var saleHeight = lastSaleHeight !== null ? lastSaleHeight : measureSaleHeightFallback();
      if (lastSaleHeight === null) {
        saleHeight = applySaleHeight(saleHeight);
      }
      if (!headerMo) return;
      var bar = headerMo.querySelector(".bh-mo__bar");
      var barHeight = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      var popupTop = bar ? Math.round(bar.getBoundingClientRect().bottom) : saleHeight + barHeight;
      if (barHeight !== lastBarHeight) {
        lastBarHeight = barHeight;
        docEl.style.setProperty("--bh-mo-bar-height", barHeight + "px");
      }
      docEl.style.setProperty("--bh-mo-popup-top", popupTop + "px");
    }

    function onAnnouncementChanged(event) {
      var detail = event && event.detail ? event.detail : {};
      var height = detail.hidden ? 0 : detail.height;
      if (typeof height !== "number" || !Number.isFinite(height)) {
        height = measureSaleHeightFallback();
      }
      applySaleHeight(height);
      scheduleLayout();
    }

    function onAnnouncementClose() {
      applySaleHeight(0);
      scheduleLayout();
    }

    function scheduleLayout() {
      if (layoutFrame === null) layoutFrame = window.requestAnimationFrame(measureLayout);
    }

    function syncLayoutNow() {
      if (layoutFrame !== null) {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = null;
      }
      measureLayout();
    }

    function resetMobileItems() {
      root.querySelectorAll(".bh-mo .bh-mo__item.is-active").forEach(function (item) {
        item.classList.remove("is-active");
        var head = item.querySelector(".bh-mo__head");
        var body = item.querySelector(".bh-mo__body");
        if (head) head.setAttribute("aria-expanded", "false");
        if (body) {
          body.setAttribute("aria-hidden", "true");
          setInert(body, true);
        }
        item.querySelectorAll(".bh-mo__child-item.is-active").forEach(function (child) {
          child.classList.remove("is-active");
          var childHead = child.querySelector(".bh-mo__child-head");
          var products = child.querySelector(".bh-mo__products");
          if (childHead) childHead.setAttribute("aria-expanded", "false");
          if (products) {
            products.setAttribute("aria-hidden", "true");
            setInert(products, true);
          }
        });
      });
    }

    function setToggleLabel(open) {
      if (!toggle) return;
      var label = toggle.getAttribute(open ? "data-label-close" : "data-label-open");
      toggle.setAttribute("aria-label", label || (open ? "Close menu" : "Open menu"));
    }

    function closeMobileMenu(options) {
      options = options || {};
      if (mobileFocusFrame !== null) {
        window.cancelAnimationFrame(mobileFocusFrame);
        focusFrames.delete(mobileFocusFrame);
        mobileFocusFrame = null;
      }
      if (!headerMo || !headerMo.classList.contains("is-open")) {
        unlockScroll();
        return;
      }
      headerMo.classList.remove("is-open");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      setToggleLabel(false);
      if (popup) {
        popup.setAttribute("aria-hidden", "true");
        setInert(popup, true);
      }
      if (!options.keepItems) resetMobileItems();
      unlockScroll();
      restoreHeaderTransform();
      if (options.restoreFocus !== false && toggle && document.contains(toggle)) {
        toggle.focus({ preventScroll: true });
      }
    }

    function openMobileMenu() {
      if (!headerMo || headerMo.classList.contains("is-open")) return;
      normalizeHeaderTransform();
      headerMo.classList.add("is-open");
      if (toggle) toggle.setAttribute("aria-expanded", "true");
      setToggleLabel(true);
      if (popup) {
        popup.setAttribute("aria-hidden", "false");
        setInert(popup, false);
      }
      lockScroll();
      syncLayoutNow();
      mobileFocusFrame = scheduleFocus(function () {
        mobileFocusFrame = null;
        if (!headerMo.classList.contains('is-open')) return;
        var firstItem = popup ? popup.querySelector(".bh-mo__head") : null;
        if (firstItem) firstItem.focus({ preventScroll: true });
      });
    }

    function openMoItem(item) {
      item.classList.add("is-active");
      var head = item.querySelector(".bh-mo__head");
      var body = item.querySelector(".bh-mo__body");
      if (head) head.setAttribute("aria-expanded", "true");
      if (body) {
        body.setAttribute("aria-hidden", "false");
        setInert(body, false);
      }
    }

    if (popup) {
      popup.setAttribute("aria-hidden", "true");
      setInert(popup, true);
    }
    setToggleLabel(false);

    listen(toggle, "click", function () {
      if (headerMo.classList.contains("is-open")) closeMobileMenu();
      else openMobileMenu();
    });

    root.querySelectorAll(".bh-mo .bh-mo__item").forEach(function (item) {
      var head = item.querySelector(".bh-mo__head");
      var body = item.querySelector(".bh-mo__body");
      if (body) setInert(body, true);
      if (!head) return;
      var hasPanel = item.getAttribute("data-has-panel") === "1";
      listen(head, "click", function () {
        if (!hasPanel) {
          closeMobileMenu({ restoreFocus: false });
          var link = item.getAttribute("data-link");
          if (link && link !== "#" && link.indexOf("javascript") !== 0) window.location.href = link;
          return;
        }
        if (item.classList.contains("is-active")) {
          item.classList.remove("is-active");
          head.setAttribute("aria-expanded", "false");
          if (body) {
            body.setAttribute("aria-hidden", "true");
            setInert(body, true);
          }
        } else openMoItem(item);
      });
    });

    root.querySelectorAll(".bh-mo .bh-mo__child-item").forEach(function (child) {
      var head = child.querySelector(".bh-mo__child-head");
      var products = child.querySelector(".bh-mo__products");
      if (products) setInert(products, true);
      if (!head) return;
      listen(head, "click", function () {
        var willOpen = !child.classList.contains("is-active");
        child.classList.toggle("is-active", willOpen);
        head.setAttribute("aria-expanded", willOpen ? "true" : "false");
        if (products) {
          products.setAttribute("aria-hidden", willOpen ? "false" : "true");
          setInert(products, !willOpen);
        }
      });
    });

    listen(document, "click", function (event) {
      if (!headerMo || !headerMo.classList.contains("is-open")) return;
      if (event.target instanceof Element && event.target.closest("#beauty-header .bh-mo")) return;
      closeMobileMenu({ keepItems: true });
    });

    listen(document, "keydown", function (event) {
      if (!headerMo || !headerMo.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closeMobileMenu({ keepItems: true });
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = Array.from(
        headerMo.querySelectorAll("a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])"),
      ).filter(function (element) {
        return !element.closest("[inert]") && element.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    listen(window, "resize", function () {
      if (window.matchMedia(DESKTOP_QUERY).matches) {
        closeMobileMenu({ restoreFocus: false });
      }
      // Resize may change sale height without an event — refresh from DOM as fallback
      applySaleHeight(measureSaleHeightFallback());
      scheduleLayout();
    });
    listen(window, "scroll", onWindowScroll, { passive: true });
    listen(document, "site-announcement-bar:changed", onAnnouncementChanged);
    listen(document, "site-announcement-bar:close", onAnnouncementClose);
    listen(document, "touchmove", preventBackgroundScroll, { passive: false });
    listen(document, "wheel", preventBackgroundScroll, { passive: false });

    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(function () {
        applySaleHeight(measureSaleHeightFallback());
        scheduleLayout();
      });
      var bar = headerMo ? headerMo.querySelector(".bh-mo__bar") : null;
      var sale = document.querySelector(".sale-tab-bar-sticky");
      if (bar) resizeObserver.observe(bar);
      if (sale) resizeObserver.observe(sale);
    }
    // Seed from DOM once before first announcement event (Theme Editor / late CE)
    applySaleHeight(measureSaleHeightFallback());
    scheduleLayout();

    return {
      destroy: function () {
        closeMobileMenu({ restoreFocus: false });
        abortController.abort();
        focusFrames.forEach(function (frame) { window.cancelAnimationFrame(frame); });
        focusFrames.clear();
        if (layoutFrame !== null) window.cancelAnimationFrame(layoutFrame);
        if (resizeObserver) resizeObserver.disconnect();
        restoreHeaderTransform();
        docEl.style.removeProperty("--bh-mo-popup-top");
        roots.delete(root);
        delete root.__beautyHeaderController;
      },
    };
  }

  function findRoots(scope) {
    var matches = [];
    if (scope instanceof Element && scope.matches("#beauty-header")) matches.push(scope);
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll("#beauty-header").forEach(function (root) {
        matches.push(root);
      });
    }
    return matches;
  }

  function init(scope) {
    findRoots(scope).forEach(function (root) {
      if (root.__beautyHeaderController) return;
      root.__beautyHeaderController = createController(root);
      roots.add(root);
    });
  }

  function destroy(scope) {
    findRoots(scope).forEach(function (root) {
      if (root.__beautyHeaderController) root.__beautyHeaderController.destroy();
    });
  }

  window.__beautyHeaderBootstrap = { init: init, destroy: destroy };
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    destroy(event.target);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
